import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    overflow: 'hidden',
  },
  touchable: {
    flex: 1,
  },
  priorityIndicator: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
  },
  content: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingVertical: 16,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  icon: {
    fontSize: 20,
    marginRight: 12,
  },
  titleContainer: {
    flex: 1,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: '#2C3E50',
    marginBottom: 2,
  },
  timestamp: {
    fontSize: 12,
    color: '#95A5A6',
  },
  headerRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  dismissButton: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#F8F9FA',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dismissButtonText: {
    fontSize: 18,
    color: '#95A5A6',
    fontWeight: '300',
  },
  contentText: {
    fontSize: 14,
    color: '#34495E',
    lineHeight: 20,
    marginBottom: 8,
  },
  reasoningToggle: {
    paddingVertical: 8,
  },
  reasoningToggleText: {
    fontSize: 12,
    color: '#3498DB',
    fontWeight: '500',
  },
  reasoningContainer: {
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    padding: 12,
    marginTop: 8,
    borderLeftWidth: 3,
    borderLeftColor: '#3498DB',
  },
  reasoningText: {
    fontSize: 13,
    color: '#2C3E50',
    lineHeight: 18,
    marginBottom: 8,
  },
  factorsContainer: {
    marginTop: 8,
  },
  factorsTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#7F8C8D',
    marginBottom: 4,
  },
  factorText: {
    fontSize: 11,
    color: '#95A5A6',
    lineHeight: 16,
  },
  actionContainer: {
    backgroundColor: '#E8F5E8',
    borderRadius: 6,
    padding: 8,
    marginTop: 8,
  },
  actionText: {
    fontSize: 12,
    color: '#27AE60',
    fontWeight: '500',
  },
  // Notification type specific styles
  celebrationNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#F39C12',
  },
  reminderNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#E74C3C',
  },
  recommendationNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#3498DB',
  },
  masteryNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#9B59B6',
  },
  adaptationNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#1ABC9C',
  },
  socialNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#E67E22',
  },
  reEngagementNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#2ECC71',
  },
  defaultNotification: {
    borderLeftWidth: 4,
    borderLeftColor: '#95A5A6',
  },
});
